module.exports = __webpack_public_path__ + "a8a10a3e/img/product-icon-grey.b248963c.svg";